module.exports = "/images/Receive.svg";